import { FilterAsyncChip } from 'common/components/FilterChip/FilterAsyncChip';
import { useAtom, useSetAtom, WritableAtom } from 'jotai';
import { SetStateAction } from 'react';
import { fetchMno } from 'simInventory/SimInventoryApi/mnoApi';
import { FilterChip } from './FilterChip';
import { MNO_STATUS_FILTER } from '../Sim/constants/mnoStatus';

type MnosChipsProps = {
  mnoAtom: WritableAtom<(string | null)[], [SetStateAction<(string | null)[]>], void>;
  mnoNamesFilterAtom: WritableAtom<string[], [SetStateAction<string[]>], void>;
  mnoIdFilterAtom: WritableAtom<(number | null)[], [SetStateAction<(number | null)[]>], void>;
};

export const MnosChips = ({ mnoAtom, mnoNamesFilterAtom, mnoIdFilterAtom }: MnosChipsProps) => {
  const [mnos, setMnos] = useAtom(mnoAtom);
  const setMnoNames = useSetAtom(mnoNamesFilterAtom);
  const setMnoIds = useSetAtom(mnoIdFilterAtom);

  const onClear = (id: string | null, index: number) => {
    setMnos((currentAccounts) => currentAccounts.filter((account) => account !== id));
    setMnoNames((currentMnoNames) => currentMnoNames.filter((_name, i) => i !== index));
    setMnoIds((currentMnoIds) => currentMnoIds.filter((_name, i) => i !== index));
  };

  if (mnos.length === 0) {
    return null;
  }

  return (
    <>
      {mnos.map((mno, index) => {
        if (mno === MNO_STATUS_FILTER.BLANK) {
          return (
            <FilterChip
              key={mno}
              text="Mobile Network Operator: blank"
              onClose={() => {
                onClear(mno, index);
              }}
            />
          );
        }

        return (
          <FilterAsyncChip
            key={mno}
            labelPrefix="Mobile Network Operator"
            onCancel={() => {
              onClear(mno, index);
            }}
            fieldName="name"
            queryFn={() => {
              return fetchMno(mno);
            }}
            queryKey={['mno', mno]}
            queryEnabled={!!mno}
          />
        );
      })}
    </>
  );
};
